// extracted by mini-css-extract-plugin
export default {"container":"styles_container__d986j","iconMenu":"styles_iconMenu__GlWV9","searching":"styles_searching__o01Hs"};